import { render, staticRenderFns } from "./Friendship.vue?vue&type=template&id=d7e94330&scoped=true"
import script from "./Friendship.vue?vue&type=script&lang=ts"
export * from "./Friendship.vue?vue&type=script&lang=ts"
import style0 from "./Friendship.vue?vue&type=style&index=0&id=d7e94330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e94330",
  null
  
)

export default component.exports